import CustomComponent from "../CustomComponent";
import Request from "../../utils/Request";
import { FAVORITE_TOGGLE_EVENT } from "../Cards/FavoriteVenueCard";

const FAVORITE_VENUE_TYPE = 'favoriteVenue';

export class VenueCarouselComponent extends CustomComponent {
  static key = 'lta-venue-carousel';

  static get observedAttributes() {
    return ['api-url', 'add-to-favorites-url', 'remove-from-favorites-url'];
  }

  constructor() {
    super();
    this.state = {
      sections: [{
        title: 'Featured Venues',
        data: []
      }]
    };
  }

  onLoad() {
    this.fetchVenueData();
    this.addEventListener(FAVORITE_TOGGLE_EVENT, (event) => {
      this.fetchVenueData();
    });
  }

  async fetchVenueData() {
    const { apiUrl } = this.props;
    const response = await Request.get(`${apiUrl}`).catch((error) => console.log(error));
    if (response?.errors?.errorCode === '00') {
      this.setState({
        sections: response.response
      });
    }
  }

  renderVenueCard(item) {
    return `
      <lta-venue-card 
        venue-id="${item?.id}" 
        venue-name="${item?.name}" 
        venue-image-url="${item?.imageUrl}" 
        venue-distance-away="${item?.distanceAway}" 
        venue-cta-button-label="${item?.ctaButtonLabel}" 
        venue-cta-button-url="${item?.venueDetailPageUrl}" 
        venue-detail-page-url="${item?.venueDetailPageUrl}">
      </lta-venue-card>
    `;
  }

  renderFavouriteVenueCard(itemData) {
    return `
      <lta-favorite-venue-card 
        venue-id="${itemData?.id}" 
        venue-name="${itemData?.name}" 
        venue-image-url="${itemData?.imageUrl}" 
        venue-city="${itemData?.address?.city}"
        venue-postalcode="${itemData?.address?.postalcode}"
        venue-cta-button-label="${itemData?.ctaButtonLabel}" 
        venue-detail-page-url="${itemData?.venueDetailPageUrl}"
        is-favorite="${itemData?.isFavorite}"
        add-to-favorites-url="${this.props?.addToFavoritesUrl}"
        remove-from-favorites-url="${this.props?.removeFromFavoritesUrl}">
      </lta-favorite-venue-card>
    `;
  }

  renderSection(section) {
    const title = section.title || 'Venues';
    const sectionTitle = section.titleHTML || `<lta-section-header title="${title}"></lta-section-header>`;
    let items = section?.data || [];
    
    // if (section.type === FAVORITE_VENUE_TYPE) {
    //   items = items.filter((item) => !!item.isFavorite);
    // }

    if(items.length === 0) {
      return '';
    }

    return `
      <div class="l-lta-grid">
        <div class="g-col-12">
          ${sectionTitle}
        </div>
        <div class="g-col-12">
          <lta-carousel-v2 slides-xl="3">
            ${items?.map((item) => `
              <div class="swiper-slide">
                ${section.type === FAVORITE_VENUE_TYPE ? this.renderFavouriteVenueCard(item) : this.renderVenueCard(item)}
              </div>
            `).join('')}
          </lta-carousel-v2>
        </div>
      </div>
    `;
  }

  render() {
    return `
      <div class="lta-court-area">
        ${this.state?.sections?.map((section) => {
          return section?.data?.length > 0 ? this.renderSection(section) : '';
        }).join('')}
      </div>
    `;
  }
}

export default VenueCarouselComponent;